import { render, staticRenderFns } from "./TV.vue?vue&type=template&id=0c8e2bf0"
import script from "./TV.vue?vue&type=script&lang=ts"
export * from "./TV.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports